import { some, forEach } from 'lodash';
import React from 'react';

import connect from 'components/lib/connect';
import FeatureNotification from './feature_notification';
import FeatureNotificationTypes from 'scripts/domain/models/agent_notification/feature_notification_types';
import useIsFeatureEnabled from 'components/hooks/use_is_feature_enabled';

const roadmapWebinarJuly2026 = {
  feature: FeatureNotificationTypes.IN_APP_NOTIFICATION,
  roleFlags: [],
  orgIds: [],
  key: 'roadmapWebinarJuly2026',
  text: 'Product Roadmap Webinar — Thursday, July 9',
  subtext:
    'Join us on Thursday, July 9 at 11 a.m. PT for our quarterly product roadmap webinar. Hear the latest from the Gladly Product and Engineering teams, including what we’ve been building, recent product updates, and a sneak peek at what’s coming next.',
  url: 'https://www.gladly.ai/webinars/gladly-product-roadmap-2026-july/',
  urlText: 'Register',
  endAt: '2026-07-09T19:00:00.000Z',
};

const navigationRefreshJuly2026 = {
  feature: FeatureNotificationTypes.IN_APP_NOTIFICATION,
  roleFlags: [],
  orgIds: [],
  key: 'navigationRefreshJuly2026',
  text: 'Navigation refresh coming soon—preview in UAT starting July 9',
  subtext:
    'Gladly’s navigation is being reorganized into three main groups—Gladly AI, Gladly Team and Admin. It’s available to preview in your UAT environment starting July 9, and officially rolls out on July 22. Capabilities and permissions stay exactly the same—just a clearer layout.',
  url: 'https://help.gladly.com/docs/refreshed-main-navigation-bar',
  urlText: 'See what’s changing →',
  startAt: '2026-07-08T00:00:00.000Z',
  endAt: '2026-07-22T06:59:59.000Z',
};

const CURRENT_FEATURES = [roadmapWebinarJuly2026, navigationRefreshJuly2026];

export function FeatureNotificationList({ agentPreferences, organization }) {
  const isFeatureEnabled = useIsFeatureEnabled();

  let featureNotifications = [];
  forEach(CURRENT_FEATURES, featureProps => {
    if (shouldShowNotification(featureProps, agentPreferences, isFeatureEnabled, organization)) {
      featureNotifications.push(<FeatureNotification {...featureProps} />);
    }
  });

  if (!featureNotifications.length) {
    return null;
  }

  return <React.Fragment>{featureNotifications}</React.Fragment>;
}

const FeatureNotificationListContainer = connect(mapStateToProps)(FeatureNotificationList);

function mapStateToProps({ getProvider }) {
  const agentPreferences = getProvider('agentPreferences').get();
  const organization = getProvider('auth').get()?.claims;

  return {
    agentPreferences,
    organization,
  };
}

export function useHasFeaturesToShow(agentPreferences, organization) {
  const isFeatureEnabled = useIsFeatureEnabled();
  return some(CURRENT_FEATURES, featureProps => {
    return shouldShowNotification(featureProps, agentPreferences, isFeatureEnabled, organization);
  });
}

function shouldShowNotification(featureProps, agentPreferences, isFeatureEnabled, organization) {
  const roleRestricted = featureProps.roleFlags && featureProps.roleFlags.length;
  const restrictedAndHasRole = some(featureProps.roleFlags, roleFlag => isFeatureEnabled(roleFlag));
  const flagRestricted = featureProps.flag;

  const organizationId = organization?.id || organization?.orgId || '';
  const orgRestricted = !!featureProps.orgIds.length;
  const belongsToOrg = some(featureProps.orgIds, orgId => orgId.toLowerCase() === organizationId.toLowerCase());

  const currentTime = new Date();
  const startRestricted = !!featureProps.startAt;
  const afterStart = startRestricted ? currentTime > new Date(featureProps.startAt) : true;
  const endRestricted = !!featureProps.endAt;
  const beforeEnd = endRestricted ? currentTime < new Date(featureProps.endAt) : true;

  return (
    (!orgRestricted || belongsToOrg) &&
    (!roleRestricted || restrictedAndHasRole) &&
    (!flagRestricted || isFeatureEnabled(featureProps.flag)) &&
    afterStart &&
    beforeEnd &&
    !agentPreferences.hasSeenFeatureNotification(featureProps.feature)
  );
}

export default FeatureNotificationListContainer;
